var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-player-layout"},[_c('transition',{key:_vm.$route.path,attrs:{"name":"fade"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }